import { useEffect, useState } from "react";
import { ReactSVG } from "react-svg";
import { XMarkIcon } from "@heroicons/react/24/outline";

export default function Alert({
  title,
  content,
  confirmAction = {},
  type = "primary",
  className = "",
  isWrapped = false,
  handleClose = () => {},
  hideCross = false,
  compact = false,
  showTexture = true,
}) {
  const hasRenderableAlert =
    Boolean(title) ||
    (typeof content === "function" || Boolean(content));

  if (!hasRenderableAlert) return null;

  let [alertAttributes, setAlertAttributes] = useState({
    typeClassName: "",
    typeIconUrl: "",
  });

  const alertColorAndIcon = (_key) => {
    switch (_key) {
      case "primary":
        return setAlertAttributes({
          typeClassName: "bg-blue-100 border-REELTeal",
          typeIconUrl: "/icons/caution-blue.svg",
        });
        break;
      case "danger":
        return setAlertAttributes({
          typeClassName: "bg-red-50 border-red-200",
          typeIconUrl: "/icons/close-circle.svg",
        });
        break;
      case "warning":
        return setAlertAttributes({
          typeClassName: "bg-yellow-50 border-yellow-200",
          typeIconUrl: "/icons/warning.svg",
        });
        break;
      case "success":
        return setAlertAttributes({
          typeClassName: "bg-green-50 border-green-200",
          typeIconUrl: "/icons/success-toast.svg",
        });
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    alertColorAndIcon(type);
  }, [type]);

  return (
    <div
      className="px-1 py-1 bg-center"
      style={{
        backgroundImage: hasRenderableAlert && showTexture
          ? "url(/icons/texture-background.png)"
          : "none",
        backgroundRepeat: "repeat",
      }}
    >
      <div
        className={`flex items-center col-span-12 border rounded ${alertAttributes.typeClassName} ${className}`}
      >
        <div
          className={`flex w-full  ${
            compact ? "p-[6px]" : "p-[14px]"
          } justify-between ${!isWrapped ? "" : "items-center"}`}
        >
          <div className={`flex space-x-4 ${!isWrapped ? "" : "items-center"}`}>
            <ReactSVG
              src={alertAttributes.typeIconUrl}
              className={compact ? "w-5 h-5" : "w-10 h-10"}
            />
            {/* <div className="flex items-center justify-between w-full gap-4"> */}
            <div
              className={`${
                !isWrapped ? "flex items-center justify-between w-full" : ""
              }`}
            >
              {title && <h6 className={`font-semibold ${type === 'danger' || type === 'primary' ? 'text-teal-300' : ''}`}>{title}</h6>}
              {!isWrapped && content && <div className="mx-1">-</div>}
              <div className="flex items-center justify-between text-gray-700 text-body-md">
                {typeof content === 'function' ? (
                  // <div dangerouslySetInnerHTML={{ __html: content() }} />
                  content()
                ) : typeof content === 'string' ? (
                  content
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: content }} />
                )}
                
              </div>
            </div>
            {/* </div> */}
          </div>
          {!hideCross && (
            <div className="relative -top-4 -right-4">
              <button
                className="flex items-center justify-center w-8 h-8 ml-auto"
                onClick={handleClose}
              >
                <XMarkIcon strokeWidth={2} className="w-4 h-4 cursor-pointer" />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
